import { useMemo, useState } from 'react';

import type { IncidentListRow } from '@ngsos/portal-core/incidents';
import { incidentMarker } from './markers';
import { IncidentListMapComponent, useAgencyMapConfiguration } from './IncidentListMapComponent';
import { IncidentMarkerDetailTemplate } from './IncidentMarkerDetailTemplate';
import { PopupView } from './PopupView';

export type IncidentListMapProps = {
  incidents?: readonly IncidentListRow[] | null;
  disableControls?: boolean;
};

export function IncidentListMap({ incidents, disableControls = false }: IncidentListMapProps) {
  const mapConfiguration = useAgencyMapConfiguration();

  const [center] = useState(() => mapConfiguration.defaultPosition);
  const [zoom] = useState(() => mapConfiguration.defaultZoom);

  const [incidentDetail, setIncidentDetail] = useState<IncidentListRow | null>(null);

  const effectiveMarkers = useMemo(
    () =>
      (incidents ?? [])
        .filter((incident) => incident.currentLocation != null)
        .map((incident) =>
          incidentMarker(incident.id, [incident.currentLocation!.latitude, incident.currentLocation!.longitude]),
        ),
    [incidents],
  );

  const onMarkerClicked = (markerId: string) => {
    setIncidentDetail(incidents?.find((incident) => incident.id === markerId) ?? null);
  };

  return (
    <IncidentListMapComponent
      center={center}
      zoom={zoom}
      items={effectiveMarkers}
      disableControls={disableControls}
      onMarkerClicked={onMarkerClicked}
      popupContent={
        <PopupView show={incidentDetail != null} onClose={() => setIncidentDetail(null)}>
          {incidentDetail != null && <IncidentMarkerDetailTemplate item={incidentDetail} />}
        </PopupView>
      }
    />
  );
}
